<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <div class="search">
                <form action="search-results.html" method="get">
                     <label> </label>
                    <input id="search" name="search" type="text" [(ngModel)]="strcode" (change)="retriveIPrepLookUp()" placeholder="Serial"  >
                    <label>       </label>

                    <label>       </label>
                    <input id="search" name="search" type="text" [(ngModel)]="strdesc1" (change)="retriveIPrepLookUp()" placeholder="Name">

                </form>
            </div>
        </div>
    </div>
  </section>

  <table style="Height: 15px;">
    <thead>
        <tr >
            <th style="width: 20%;height: 5px;">Serial</th>
            <th style="width: 90%;height: 5px;">Name</th>
            <th style="width: 20%;height: 5px;">Choose</th>
        </tr>
    </thead>
    <tbody>
      <tr *ngFor="let pro of storesList; let i = index">
            <td data-column="Protocol ID">{{pro.strcode}}</td>
            <td data-column="Protocol Name">{{pro.strdesc1}}</td>
            <td data-column="Choose"><button type="button" class="theme-button btn" name="select" id="select" (click)="Selectstore(pro)">Select</button>
            </td>
        </tr>

    </tbody>
  </table>
  </mat-dialog-content>




